import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";


async function requisicaoPay(rota, dados) {
    if (!JwtService.getToken()) return { resultado: false, erro: "Sessão expirada.", msg: "Entre novamente no Desk." };
    ApiService.setHeader();
    try { return (await ApiService.postOnce(rota, dados)).data; }
    catch (e) {
        const msg = e.response?.data?.erro || e.response?.data?.msg || e.response?.data?.message || "Operação sem confirmação. Consulte a situação antes de repetir.";
        return { resultado: false, erro: msg, msg, REGISTROS: [], QUANTIDADE: 0 };
    }
}

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getPayClientes(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return requisicaoPay("payClientes/access/listar", dados);
    }, 
    getPayCliente(context, dados) {
        return requisicaoPay("payClientes/access/obter", { ID_PAY_CLIENTE: dados.id, componente: dados.componente });
    }, 
    deletePayCliente(context, dados) {
        return requisicaoPay("payClientes/access/excluir", { ID_PAY_CLIENTE: dados.id, componente: dados.componente });
    }, 
    postPayCliente(context, dados) {
        return requisicaoPay("payClientes/access/salvar", dados);
    }, 
    postPayClienteSincronizarAdquirente(context, idPayCliente) {
        return requisicaoPay("payClientes/access/sincronizarAdquirente", {ID_PAY_CLIENTE: idPayCliente});
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};